(() => {
  const createSelectionState = (variants, selectedId) => {
    const find = id => variants.find(item => String(item.id) === String(id));
    let focused = find(selectedId) || variants[0], slots = focused ? [String(focused.id)] : [];
    return {
      focus(id) { const variant = find(id); if (!variant) return; focused = variant; if (slots.length === 1) slots[0] = String(id); },
      setPack(count) {
        if (![1, 3, 5].includes(count) || !focused) return;
        if (count === 1) { slots = [String(focused.id)]; return; }
        const candidates = variants.filter(item => item.available), choices = candidates.length ? candidates : variants;
        if (slots.length === 1 && candidates.length && !find(slots[0])?.available) slots[0] = String(candidates[0].id);
        slots = slots.slice(0, count);
        while (slots.length < count) {
          const next = choices.find(item => !slots.includes(String(item.id))) || choices[slots.length % choices.length];
          slots.push(String(next.id));
        }
      },
      setSlot(index, id) { if (!find(id) || index < 0 || index >= slots.length) return; slots[index] = String(id); focused = find(id); },
      snapshot() {
        const counts = new Map();
        for (const id of slots) counts.set(id, (counts.get(id) || 0) + 1);
        return { focused, slots: [...slots], packSize: slots.length, items: [...counts].map(([id, quantity]) => ({ id, quantity })), totalCents: slots.reduce((sum, id) => sum + Number(find(id)?.priceCents || 0), 0) };
      }
    };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { createSelectionState };
  if (typeof document === 'undefined') return;
  const initialize = () => document.querySelectorAll('[data-difold-product]').forEach(root => {
    if (root.dataset.difoldReady) return;
    const source = root.querySelector('[data-difold-data]');
    let data = {}, variants = [];
    try { data = JSON.parse(source?.textContent || '{}'); if (Array.isArray(data.variants)) variants = data.variants; }
    catch { console.warn('DiFold variant details could not be loaded.'); }
    root.dataset.difoldReady = 'true';
    const media = [...root.querySelectorAll('[data-difold-media]')], thumbs = [...root.querySelectorAll('[data-difold-thumb]')];
    const swatches = [...root.querySelectorAll('[data-difold-swatch]')], state = createSelectionState(variants, data.selectedId);
    const form = root.querySelector('[data-difold-main-form="true"]');
    const money = cents => new Intl.NumberFormat(data.locale || 'en-US', { style: 'currency', currency: data.currency || 'USD' }).format(cents / 100);
    const colorOf = id => swatches.find(button => button.dataset.difoldSwatch === String(id))?.dataset.colorValue || '#dedbd5';
    root.getDiFoldSelection = () => {
      const selected = state.snapshot();
      return { productHandle: data.productHandle, packSize: selected.packSize, items: selected.items, inventoryConfirmed: data.inventoryConfirmed === true };
    };
    let current = Math.max(0, media.findIndex(node => !node.hidden));
    const showMedia = index => {
      if (!media.length) return;
      current = (index + media.length) % media.length;
      media.forEach((node, position) => {
        node.hidden = position !== current;
        const external = node.querySelector('[data-difold-external]');
        if (node.hidden) { node.querySelectorAll('video').forEach(video => video.pause()); if (external) node.querySelectorAll('iframe').forEach(frame => frame.remove()); }
        else if (external && !node.querySelector('iframe')) node.append(external.content.cloneNode(true));
      });
      thumbs.forEach((node, position) => node.setAttribute('aria-pressed', String(position === current)));
      const counter = root.querySelector('[data-difold-count]');
      if (counter) counter.textContent = `${current + 1} / ${media.length}`;
    };
    const renderSelection = (changeHero = false) => {
      const selected = state.snapshot(), variant = selected.focused;
      if (!variant) return;
      const price = root.querySelector('[data-difold-price]'), compare = root.querySelector('[data-difold-compare]'), colorName = root.querySelector('[data-difold-color-name]');
      if (price) price.innerHTML = variant.price;
      if (compare) { compare.innerHTML = variant.compareAtPrice; compare.hidden = !variant.onSale; }
      if (colorName) colorName.textContent = variant.title;
      swatches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.difoldSwatch === String(variant.id))));
      root.querySelectorAll('[data-difold-pack]').forEach(button => {
        const count = Number(button.dataset.difoldPack);
        button.setAttribute('aria-pressed', String(count === selected.packSize));
        button.querySelector('[data-difold-pack-total]').textContent = money(Number(variant.priceCents) * count);
        button.querySelector('[data-difold-pack-unit]').textContent = money(Number(variant.priceCents));
      });
      const rows = root.querySelector('[data-difold-slots]'), total = root.querySelector('[data-difold-selection-total]');
      if (rows) rows.hidden = selected.packSize === 1;
      if (total) { total.hidden = selected.packSize === 1; total.querySelector('[data-difold-total]').textContent = money(selected.totalCents); }
      root.querySelectorAll('[data-difold-slot-row]').forEach(row => {
        const index = Number(row.dataset.difoldSlotRow), id = selected.slots[index];
        row.hidden = selected.packSize === 1 || !id;
        if (!id) return;
        row.querySelector('[data-difold-slot]').value = id;
        row.querySelector('[data-difold-slot-color]').style.backgroundColor = colorOf(id);
        const item = variants.find(value => String(value.id) === id), stock = row.querySelector('[data-difold-slot-stock]');
        stock.textContent = item?.available ? data.inStock : data.soldOut;
        stock.dataset.available = String(Boolean(item?.available));
      });
      if (form) {
        const quantity = form.querySelector('[name="quantity"]'), id = form.querySelector('[name="id"]');
        if (quantity) quantity.value = String(selected.packSize);
        if (id) { id.value = selected.slots[0]; id.disabled = selected.packSize > 1 && root.dataset.difoldMixedReady !== 'true'; }
      }
      if (changeHero) {
        const position = media.findIndex(node => node.dataset.difoldMedia === String(variant.mediaId));
        if (position >= 0) showMedia(position);
        const url = new URL(window.location.href); url.searchParams.set('variant', String(variant.id)); history.replaceState({}, '', url);
      }
      root.dispatchEvent(new CustomEvent('difold:selectionchange', { detail: root.getDiFoldSelection(), bubbles: true }));
    };
    root.addEventListener('change', event => {
      if (event.target.matches('[data-difold-slot]')) { state.setSlot(Number(event.target.dataset.difoldSlot), event.target.value); renderSelection(true); }
      else if (event.target.matches('[data-difold-select], select[id^="native-option-"]')) { state.focus(event.target.value); renderSelection(true); }
    });
    root.addEventListener('click', event => {
      const swatch = event.target.closest('[data-difold-swatch]'), pack = event.target.closest('[data-difold-pack]'), thumb = event.target.closest('[data-difold-thumb]');
      if (swatch) { state.focus(swatch.dataset.difoldSwatch); renderSelection(true); }
      else if (pack) { state.setPack(Number(pack.dataset.difoldPack)); renderSelection(); }
      else if (thumb) showMedia(media.findIndex(node => node.dataset.difoldMedia === thumb.dataset.difoldThumb));
      else if (event.target.closest('[data-difold-prev]')) showMedia(current - 1);
      else if (event.target.closest('[data-difold-next]')) showMedia(current + 1);
    });
    root.addEventListener('difold:planchange', event => {
      if (data.inventoryConfirmed !== true) return;
      const status = root.querySelector('[data-difold-status]');
      if (status) status.textContent = event.detail?.error || (event.detail?.plan ? data.inStock : '');
      const total = root.querySelector('[data-difold-total]'), amount = event.detail?.plan?.merchandiseCents;
      if (total && !event.detail?.error && Number.isSafeInteger(amount) && amount >= 0) total.textContent = money(amount);
    });
    showMedia(current);
    renderSelection();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
